export function readingTime(wordCount: number | undefined): string {
  const wordsPerMinute = 250;
  if (!wordCount) {
    return '';
  }
  return Math.ceil(wordCount / wordsPerMinute) + ' min read';
}
